module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-01@2x.7a11dc7.jpg";